/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { action } from '@ember/object';

interface IArgs {
  open: boolean;
  title?: string;
  body?: string;
  cancelButtonText?: string;
  submitButtonText?: string;
  disabled?: boolean;
  scrollable?: boolean;
  subTitle?: string;
  submitButtonType?: 'danger';
  onSubmit?(): void;
  onCancel?(): unknown;
  onHidden?(): void;
}

interface ModalSignature {
  Element: HTMLDivElement;

  Args: IArgs;

  Blocks: {
    body?: [];
    footer?: [];
  };
}

export default class UiModalComponent extends Component<ModalSignature> {
  @cached
  get title(): string | undefined {
    return this.args.title;
  }

  @cached
  get body(): string | undefined {
    return this.args.body;
  }

  @cached
  get cancelButtonText(): string | undefined {
    return this.args.cancelButtonText;
  }

  @cached
  get submitButtonText(): string | undefined {
    return this.args.submitButtonText;
  }

  @cached
  get disabled(): boolean {
    return this.args.disabled ?? false;
  }

  @cached
  get submitButtonType(): string {
    return this.args.submitButtonType ?? 'primary';
  }

  @action
  handleSubmit(closeModal?: () => void): void {
    this.args.onSubmit?.();

    closeModal?.();
  }

  @action
  handleCancel(closeModal?: () => void): boolean {
    if (this.args.onCancel?.() === false) {
      return false;
    }

    closeModal?.();

    return true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Modal': typeof UiModalComponent;
  }
}
